import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Tutoring from './Tutoring';

const buildTarget = process.env.REACT_APP_BUILD_TARGET;
const hostname = window.location.hostname;

const isTutoringDomain = buildTarget === 'tutoring' ||
                        hostname === 'tutor.mohamedabdelnaby.com' ||
                        hostname === 'tutor.localhost' ||
                        hostname.includes('mohamedabdelnabytutoring');

console.log('Site Detection:');
console.log('Build Target:', buildTarget);
console.log('Hostname:', hostname);
console.log('Will render:', isTutoringDomain ? 'Tutoring Site' : 'Portfolio Site');

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    {isTutoringDomain ? <Tutoring /> : <App />}
  </React.StrictMode>
);

// If react-snap pre-rendered static HTML into #root, hydrate it.
// Otherwise, this is a fresh client mount (dev server / un-snapped build).
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}